// auth.service.ts
import { Injectable } from '@angular/core';
import { HttpClient,HttpParams, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, map } from 'rxjs/operators';
import { LoginResponse } from '../models/user';
import { Router } from '@angular/router';
import * as jwt_decode from 'jwt-decode';
import * as actionSession from '../../core/actions/session.actions';
import { Store } from '@ngrx/store';
import { Expertise } from '../models/expertise';
import { BaseService } from './base.service';
import { Prestation } from '../models/prestation';

@Injectable({
  providedIn: 'root'
})
export class NoteService extends BaseService {


  get(object_type: string, object_id: number): Observable<any> {
     let params = new HttpParams()
        .set('object_type',object_type)
        .set('object_id', object_id.toString())
      ;
    return this.http
      .get<any>(this.basePath + '/v1/notes?expand=user',{params: params, })
      .pipe(
        catchError(this.handleError)
      );
  }

  create(note: any): Observable<any> {    
      return this.http
        .post<any>(this.basePath + '/v1/notes?expand=user', note)
        .pipe(
          catchError(this.handleError)
        );
    
  }

  delete(id: any): Observable<any> {    
      return this.http
        .delete<any>(this.basePath + '/v1/notes/' + id)
        .pipe(
          catchError(this.handleError)
        );   
  }

}
